import type { FC } from 'react';

import { Icon } from '@iconik-io/uad';
import type { UploaderState } from '@iconik-io/uploader/src/state';

import { selectUploadItem } from '../../ducks/uploader/selectors';
import { useAppSelector } from '../../store/react_redux_typed';

import styles from './uploads_panel_widget.module.css';

type Props = {
  item: UploaderState;
};

const AssetIcon: FC<Props> = ({ item }) => {
  const uploadItem = useAppSelector((state) =>
    selectUploadItem(state, item.id),
  );
  return (
    <div className={styles.title_icon}>
      {uploadItem?.icon === 'file' && uploadItem.extension ? (
        <span className={styles.extension}>{uploadItem.extension}</span>
      ) : (
        <Icon name={uploadItem?.icon ?? 'file'} />
      )}
    </div>
  );
};

export default AssetIcon;
